module.exports = __webpack_public_path__ + "static/NeueEinstellungBold-85b65b8050c0b210d68f14827a8afd7b.woff";